export default __webpack_public_path__ + "static/media/main-banner.efe56738.png";